import Joi from 'joi';

export const formValidationSchema = {
  enabled: Joi.boolean().required(),
};
